// @ts-nocheck
/* eslint-disable */
import React from 'react';
import ViewEntity from '../../components/CRUD/ViewEntity';
import moment from 'moment';

import { useLocation, useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';

const ViewDiscountBand = () => {
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';
  const { pathname } = useLocation();
  const history = useHistory();
  const intl = useIntl();
  const isPromotionsRoute = pathname.includes('/fare-products/promotions');
  const productType = isPromotionsRoute ? 'Promotions' : 'FareProducts';
  const pageTitle = isPromotionsRoute ? 'PromotionInfo' : 'FareProductInfo';
  const baseUrl = isPromotionsRoute ? '/fare-products/promotions' : '/fare-products/fare-products';
  const productTerm = isPromotionsRoute ? 'Promotion' : 'Fare Product';
  const messageTransformer = (msg: string) => {
    if (!msg) return msg;
    return msg.replace(/discount bands/gi, `${productTerm}s`).replace(/discount band/gi, productTerm);
  };

  return (
    <ViewEntity
      pageTitle={pageTitle}
      fetchApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/discount_band/:id`}
      fetchApiMethod="GET"
      dataPath="data.data"
      additionalApis={[
        {
          name: 'assignmentsCount',
          url: (mainData) => `/api/v1/web_portal/fare_media_policy_capping/fare_media_policy_capping_statistics/discount-bands/${mainData.discount_bands_id}/discount-band-assignments-count`,
          method: 'GET',
          dataPath: 'data.data.discount_band_assignments_count'
        },
        {
          name: 'ticketsCount',
          url: (mainData) => `/api/v1/web_portal/fare_media_policy_capping/fare_media_policy_capping_statistics/discount-bands/${mainData.discount_bands_id}/tickets-count`,
          method: 'GET',
          dataPath: 'data.data.tickets_count'
        }
      ]}
      fields={[
        {
          name: 'code',
          labelKey: 'Code',
          type: 'text',
        },
        {
          name: 'name',
          labelKey: 'ArName',
          type: 'text',
        },
        {
          name: 'en_name',
          labelKey: 'EnName',
          type: 'text',
        },
        {
          name: 'org_en_name',
          labelKey: 'Organisation',
          type: 'custom',
          render: (data) => (
            currentLanguageCode === 'en-us' ? data.org_en_name : data.org_ar_name
          ),
        },
        {
          name: 'discount_pct',
          labelKey: 'DiscountValue',
          type: 'custom',
          render: (data) => data.discount_pct || data.discount_pct === 0 ? `${data.discount_pct}% (Percentage)` : `${data.discount_amount} (Fixed Amount)`,
        },
        {
          name: 'max_trips',
          labelKey: 'MaxTrips',
          type: 'custom',
          hidden: isPromotionsRoute,
          render: (data) => data.max_trips ? data.max_trips : '-',
        },
        {
          name: 'purchase_price',
          labelKey: 'PurchasePrice',
          type: 'custom',
          hidden: isPromotionsRoute,
          render: (data) => data.purchase_price !== null ? data.purchase_price : '-',
        },
        {
          name: 'contract_duration_days',
          labelKey: 'ContractDurationDays',
          type: 'custom',
          hidden: isPromotionsRoute,
          render: (data) => data.contract_duration_days ? data.contract_duration_days : '-',
        },
        {
          name: 'max_amount',
          labelKey: 'MaxAmount',
          type: 'custom',
          hidden: isPromotionsRoute,
          render: (data) => data.max_amount !== null ? data.max_amount : '-',
        },
        {
          name: 'activation_trigger',
          labelKey: 'ActivationTrigger',
          type: 'custom',
          hidden: isPromotionsRoute,
          render: (data) => data.activation_trigger ? data.activation_trigger : '-',
        },
        {
          name: 'requires_documents',
          labelKey: 'RequiresDocuments',
          type: 'custom',
          hidden: isPromotionsRoute,
          render: (data) => {
            if (!data.requires_documents) return 'No';
            if (data.required_document_types && data.required_document_types.length > 0) {
              const types = data.required_document_types.map(rd => 
                (currentLanguageCode === 'en-us' ? rd.en_name : rd.ar_name) || rd.en_name
              );
              return `Yes (${types.join(', ')})`;
            }
            return 'Yes';
          },
        },
        {
          name: 'valid_date_from',
          labelKey: 'ValidFrom',
          type: 'custom',
          render: (data) => data.valid_date_from ? moment(data.valid_date_from).format('DD/MM/YYYY') : '-',
        },
        {
          name: 'valid_date_to',
          labelKey: 'ValidTo',
          type: 'custom',
          render: (data) => data.valid_date_to ? moment(data.valid_date_to).format('DD/MM/YYYY') : '-',
        },
        {
          name: 'valid_time_from',
          labelKey: 'TimeFrom',
          type: 'text',
        },
        {
          name: 'valid_time_to',
          labelKey: 'TimeTo',
          type: 'text',
        },
        {
          name: 'days_of_week',
          labelKey: 'AvailableDays',
          type: 'custom',
          render: (data) => {
            const days = [];
            if (data.sunday) days.push(currentLanguageCode === 'en-us' ? 'Sunday' : 'الأحد');
            if (data.monday) days.push(currentLanguageCode === 'en-us' ? 'Monday' : 'الاثنين');
            if (data.tuesday) days.push(currentLanguageCode === 'en-us' ? 'Tuesday' : 'الثلاثاء');
            if (data.wednesday) days.push(currentLanguageCode === 'en-us' ? 'Wednesday' : 'الأربعاء');
            if (data.thursday) days.push(currentLanguageCode === 'en-us' ? 'Thursday' : 'الخميس');
            if (data.friday) days.push(currentLanguageCode === 'en-us' ? 'Friday' : 'الجمعة');
            if (data.saturday) days.push(currentLanguageCode === 'en-us' ? 'Saturday' : 'السبت');
            return days.length > 0 ? days.join(', ') : 'No days selected';
          }
        },
        {
          name: 'discount_band_assignments_count',
          labelKey: 'AssociatedDiscountBandAssignments',
          type: 'custom',
          render: (data, additionalData) => {
            return additionalData.assignmentsCount !== undefined ? additionalData.assignmentsCount : '-';
          }
        },
        {
          name: 'tickets_count',
          labelKey: 'AssociatedTickets',
          type: 'custom',
          render: (data, additionalData) => {
            return additionalData.ticketsCount !== undefined ? additionalData.ticketsCount : '-';
          }
        },
        {
          name: 'created_by_name',
          labelKey: 'CreatedBy',
          type: 'text',
        },
        {
          name: 'created_at',
          labelKey: 'CreatedAt',
          type: 'date',
        },
        {
          name: 'updated_by_name',
          labelKey: 'UpdatedBy',
          type: 'text',
        },
        {
          name: 'updated_at',
          labelKey: 'UpdatedAt',
          type: 'date',
        }
      ].filter(f => !f.hidden)}
      editUrl={`${baseUrl}/:id/edit`}
      deleteApiUrl="/api/v1/web_portal/fare_media_policy_capping/discount_band/:id"
      deleteApiMethod="PATCH"
      buildDeletePayload={(data) => ({ is_active: false })}
      backUrl={baseUrl}
      buildTitle={(data) => `${data.code}`}
      showEditButton={true}
      showDeleteButton={true}
      subsystemName={productType}
      permissionSystem="fares"
      messageTransformer={messageTransformer}
      renderActionButtons={(data, additionalData) => {
        const btnStyle = { position: 'inherit', marginTop: '-10px', paddingBottom: '7px', paddingTop: '8px', marginRight: '5px', marginLeft: '5px' };
        const recordIsFareProduct = !!data?.is_fare_product;

        if (isPromotionsRoute) {
          if (!recordIsFareProduct && additionalData?.assignmentsCount === 0) {
            return (
              <button
                type="button"
                className="styleAddBtn"
                style={{ ...btnStyle, backgroundColor: '#0FA66D' }}
                onClick={() => history.push(`/fare-products/fare-products/${data.discount_bands_id}/edit?came_from=one`)}
              >
                {intl.formatMessage({ id: 'ConvertToFareProduct' })}
              </button>
            );
          }
          return null;
        }

        if (!recordIsFareProduct || additionalData?.assignmentsCount !== 0) return null;
        return (
          <button
            type="button"
            className="styleAddBtn"
            style={{ ...btnStyle, backgroundColor: '#0FA66D' }}
            onClick={() => history.push(`/fare-products/promotions/${data.discount_bands_id}/edit?came_from=one`)}
          >
            {intl.formatMessage({ id: 'ConvertToPromotion' })}
          </button>
        );
      }}
    />
  );
};

export default ViewDiscountBand;
